import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/reloadify.webp';
import screenshot_target from '../../../images/letterfunnel/lukashietkamp.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Lukas Hietkamp"
      firstname="Lukas"
      companyname="Reloadify"
      competition="Klaviyo en Omnisend"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/lukashietkamp.js